import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const SuiteList = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.verStartInstant.sort = null;
    fieldToFieldDef.seq.sort = 'asc';
  };

  return <EntityList entity="SUITE" augFieldDefs={augFieldDefs} />;
};
